module.exports = __webpack_public_path__ + "assets/HKNova-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Bold.eot
// module id = 142
// module chunks = 0